<template>
  <div id="navigation-drawer-view">
    <v-container fluid>
      <actions
        :reportRange="reportRange"
        :vehicles="vehicles"
        @download-spreadsheet="downloadSpreadsheet"
        @download-csv="downloadCsv"
        @update-selected-vehicle="updateSelectedVehicle"
        @today-report-range="reportRange = 'today'"
        @custom-report-range="reportRange = 'custom'"
      ></actions>
      <custom-range
        v-if="reportRange === 'custom'"
        @update-start-date="updateStartDate"
        @update-finish-date="updateFinishDate"
      ></custom-range>
      <v-layout row wrap>
        <indicator
          v-for="(indicator, index) in indicators"
          :key="index"
          :title="indicator.name"
          :value="indicator.value"
        />
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <events-table
            :events="events"
            :totalEvents="totalEvents"
            :loading="loading"
            @update-pagination="updateEventsTablePagination"
          ></events-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment'

import Indicator from '@/components/Reports/Indicator'
import Actions from '@/components/Reports/Actions'
import CustomRange from '@/components/Reports/CustomRange'
import EventsTable from '@/components/Reports/EventsTable'

export default {
  name: 'reports',
  data: function () {
    return {
      selectedVehicle: null,
      loading: false,
      reportRange: 'today',
      eventsTablePagination: {},
      startDate: moment().startOf('date').valueOf(),
      finishDate: moment().endOf('date').valueOf()
    }
  },
  computed: {
    vehicles: function () {
      return this.$store.state.Reports.vehicles
    },
    events: function () {
      return this.$store.state.Reports.events
    },
    totalEvents: function () {
      return this.$store.state.Reports.totalEvents
    },
    indicators: function () {
      return this.$store.state.Reports.indicators
    }
  },
  watch: {
    reportRange: function (reportRange) {
      if (reportRange === 'today') {
        this.startDate = moment().startOf('date').valueOf()
        this.finishDate = moment().endOf('date').valueOf()
      }
    },
    selectedVehicle: function () {
      this.fetchEvents()
      this.fetchIndicators()
    },
    eventsTablePagination: function () {
      this.fetchEvents()
      this.fetchIndicators()
    },
    startDate: function () {
      this.fetchEvents()
      this.fetchIndicators()
    },
    finishDate: function () {
      this.fetchEvents()
      this.fetchIndicators()
    }
  },
  components: {
    'indicator': Indicator,
    'actions': Actions,
    'custom-range': CustomRange,
    'events-table': EventsTable
  },
  mounted: function () {
    this.$store.dispatch('Reports/fetchVehicles')
  },
  methods: {
    downloadCsv: async function () {
      const response = await this.$store.dispatch('Reports/downloadCsv', {
        vehicleId: this.selectedVehicle._id,
        startDate: this.startDate,
        finishDate: this.finishDate
      })
      if (!response) return false
      const { data, mime, filename } = response
      const blob = new Blob([data], { type: mime })
      const blobURL = window.URL.createObjectURL(blob)
      const tempLink = document.createElement('a')
      tempLink.style.display = 'none'
      tempLink.href = blobURL
      tempLink.setAttribute('download', filename)
      document.body.appendChild(tempLink)
      tempLink.click()
      document.body.removeChild(tempLink)
      window.URL.revokeObjectURL(blobURL)
    },
    downloadSpreadsheet: async function () {
      const response = await this.$store.dispatch('Reports/downloadSpreadsheet', {
        vehicleId: this.selectedVehicle._id,
        startDate: this.startDate,
        finishDate: this.finishDate
      })
      if (!response) return false
      const { data, mime, filename } = response
      const blob = new Blob([data], { type: mime })
      const blobURL = window.URL.createObjectURL(blob)
      const tempLink = document.createElement('a')
      tempLink.style.display = 'none'
      tempLink.href = blobURL
      tempLink.setAttribute('download', filename)
      document.body.appendChild(tempLink)
      tempLink.click()
      document.body.removeChild(tempLink)
      window.URL.revokeObjectURL(blobURL)
    },
    updateSelectedVehicle: function (vehicle) {
      this.selectedVehicle = vehicle
    },
    updateStartDate: function (date) {
      this.startDate = date
    },
    updateFinishDate: function (date) {
      this.finishDate = date
    },
    updateEventsTablePagination: function ({ page, rowsPerPage }) {
      this.eventsTablePagination = { page, rowsPerPage }
    },
    fetchIndicators: function () {
      if (!this.selectedVehicle || !this.startDate || !this.finishDate) {
        return false
      }
      const dispatchData = {
        vehicleId: this.selectedVehicle._id,
        mark: this.selectedVehicle.device.type.mark,
        reference: this.selectedVehicle.device.type.reference,
        startDate: this.startDate,
        finishDate: this.finishDate
      }
      this.$store.dispatch('Reports/fetchIndicators', dispatchData)
    },
    fetchEvents: async function () {
      if (!this.selectedVehicle || !this.startDate || !this.finishDate) {
        return false
      }
      const { page, rowsPerPage } = this.eventsTablePagination
      this.loading = true
      await this.$store.dispatch('Reports/countEvents', {
        vehicleId: this.selectedVehicle._id,
        startDate: this.startDate,
        finishDate: this.finishDate
      })
      if (rowsPerPage !== -1) {
        await this.$store.dispatch('Reports/fetchPaginatedEvents', {
          vehicleId: this.selectedVehicle._id,
          startDate: this.startDate,
          finishDate: this.finishDate,
          page: page,
          rowsPerPage: rowsPerPage
        })
      } else {
        await this.$store.dispatch('Reports/fetchEvents', {
          vehicleId: this.selectedVehicle._id,
          startDate: this.startDate,
          finishDate: this.finishDate
        })
      }
      this.loading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Reports.vue